// ----------------------------------------------------------------------
// <copyright file="SettingsLevel.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var DropDown = require('share/components/controls/Izenda.DropDown');
  var classnames = require('classnames');
  var connect = require('share/enhancers/Izenda.Connect');
  var settingConstant = require('logic/data/Izenda.SettingConstants');
  var uiState = require('logic/Izenda.UiState');
  var SettingsLevel = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },
    componentDidMount: function() {
      this.props.store.loadTenants();
    },

    /**
     *
     * @returns {type}
     */
    render: function() {
      var store = this.props.store;
      var localization = this.props.localization;
      var classes = classnames({
        'izenda-SettingLevel': true,
        'disabled-elm': store.settingLevel.disableSystemSetting
      });

      return !uiState.hideSystemLevel ? (
        <section className={classes}>
          <div className='form-inline'>
            {this.createRoleList(localization)}
            {this.renderTenants(localization)}
          </div>
        </section>
      ) : null;
    },

    /**
     * Build setting level element
     * @returns {Object}
     */
    createRoleList: function(localization) {
      var store = this.props.store;
      var classes = classnames({
        'form-group u_noMarginAll u_marginRight u_inlineBlock': true,
        'disabled-elm': store.settingLevel.disableRoleDropdown
      });

      return (
        <div className='form-group u_noMarginAll u_marginRight u_inlineBlock'>
          <label className='u_marginRight'>{localization.getText('SETTING_LEVEL_LABEL_SETTING_LEVEL')}</label>
          <div className='u_inlineBlock'>
            <DropDown
              options={store.settingLevel.availableLevels}
              value={store.settingLevel.selectedLevel()}
              labelField='label'
              valueField='value'
              onChange={this.changeSystemMode}
              disabled={store.settingLevel.disableRoleDropdown}
            />
          </div>
        </div>
      );
    },

    /**
     * Build list tenant element
     * @returns {Object}
     */
    renderTenants: function(localization) {
      var settingLevel = this.props.store.settingLevel;
      var disabled = this.props.store.settingLevel.disableSystemSetting;
      var classes = classnames({
        'form-group u_noMarginAll u_inlineBlock izenda-SettingLevel-TenantName': true,
        'disabled-elm': disabled
      });

      return settingLevel.showTenants() ? (
        <div className={classes}>
          <label className='u_marginLeft u_marginRight'>{localization.getText('COMMON_LABEL_TENANT_NAME')}</label>
          <div className='u_inlineBlock'>
            <DropDown
              options={settingLevel.tenants}
              value={settingLevel.selectedTenant}
              labelField='name'
              valueField='id'
              onChange={this.changeTenant}
              disabled={disabled}
            />
          </div>
        </div>
      ) : null;
    },

    changeSystemMode: function(change) {
      var store = this.props.store;
      var selectedLevel = store.settingLevel.selectedLevel();

      if (selectedLevel !== change.value) {
        return this.props
          .confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm })
          .then(function() {
            return store.changeSystemMode(change);
          });
      }
    },

    changeTenant: function(change) {
      var settingLevel = this.props.store.settingLevel;
      if (settingLevel.selectedTenant !== change.value) {
        return this.props
          .confirmDirtyForm(uiState.isDirty, { onConfirmDirtyForm: uiState.onOkDirtyForm })
          .then(function() {
            return settingLevel.changeTenant(change);
          });
      }
    }
  });
  module.exports = connect()(SettingsLevel);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/SettingsLevel/Izenda.SettingsLevel.jsx